import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const VehDieselReportView = () => {
  useAuthRedirect();
  const { id, branch } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [loading, setLoading] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
      const [searchTerm, setSearchTerm] = useState("");
      const [dieselRate, setDieselRate] = useState("");
      

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://rfs2.infraconsoft.net.in/api/diesel_report_view_own",
        {
          params: {
            month: selectedMonth,
            year: selectedYear,
            branch: branch,
            id: id,
          },
        }
      );

      console.log("API Response:", response.data.postionData);
      setData(response.data.postionData);
      setFilteredData(response.data.postionData);
    } catch (error) {
      console.error("Error fetching postionData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchDieselRate = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/get_diesel_rate");
        setDieselRate(response.data.dieselRate);
        console.log(response.data.dieselRate);
        
      } catch (error) {
        console.error("Error fetching diesel rate:", error);
      }
    };

    fetchDieselRate();
  }, []);


  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.stn_purnumber || "").toLowerCase().includes(term) ||
       String(item.stn_dpt || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // near top of the component
const [site, setSite] = useState({
  ok: true, name: "Infraconsoft", logo: null,
  address: "", email: "", phone: "", _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) { console.error("Failed to load /siteinfo", e); }
  })();
  return () => { ignore = true; };
}, []);


 const exportToExcel = () => {
  let dieselqty1 = 0;
  let bv = 0;

  // 1) Build rows (unchanged math)
  const exportData = data.map((item, index) => {
    const dieselQty = parseFloat(item.fld_dieselqty || 0);
    const basicAmount = dieselQty * dieselRate;

    dieselqty1 += dieselQty;
    bv += basicAmount;

    return {
      "S.No": index + 1,
      "Date": new Date(item.fld_vdate).toLocaleDateString("en-GB"),
      "Particulars": item.fld_vno || "",
      "Quantity": dieselQty.toFixed(2),
      "Cum. Diesel Quantity": dieselqty1.toFixed(2),
      "Basic Rate": dieselRate,
      "Basic Amount": basicAmount.toFixed(2),
      "Basic Value": bv.toFixed(2),
    };
  });

  // 2) Preserve column order & convert to AOA
  const headers = exportData.length
    ? Object.keys(exportData[0])
    : ["S.No","Date","Particulars","Quantity","Cum. Diesel Quantity","Basic Rate","Basic Amount","Basic Value"];
  const dataRows = exportData.map(r => headers.map(h => r[h] ?? ""));

  // 3) Company header + title
  const COLS = headers.length;
  const fullWidth = (text="") => [text, ...Array(COLS - 1).fill("")];
  const month = typeof selectedMonth !== "undefined" ? String(selectedMonth).padStart(2,"0") : "";
  const year = typeof selectedYear !== "undefined" ? selectedYear : "";
  const title = `Diesel Report${month && year ? ` — ${month}/${year}` : ""}`;

  const aoa = [
    fullWidth((site.name || "Infraconsoft").toUpperCase()),
    fullWidth(site.address || ""),
    fullWidth(
      [site.phone ? `Ph: ${site.phone}` : "", site.email ? `Email: ${site.email}` : ""]
      .filter(Boolean).join(" | ")
    ),
    [],                                 // spacer
    fullWidth(title),
    [],                                 // spacer
    headers,
    ...dataRows,
  ];

  // 4) Worksheet with merges, widths, freeze
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws["!merges"] = [
    { s:{r:0,c:0}, e:{r:0,c:COLS-1} }, // company name
    { s:{r:1,c:0}, e:{r:1,c:COLS-1} }, // address
    { s:{r:2,c:0}, e:{r:2,c:COLS-1} }, // phone/email
    { s:{r:4,c:0}, e:{r:4,c:COLS-1} }, // title
  ];

  // your original widths mapped to headers
  const widthMap = {
    "S.No": 6, "Date": 12, "Particulars": 20, "Quantity": 10,
    "Cum. Diesel Quantity": 20, "Basic Rate": 12, "Basic Amount": 14, "Basic Value": 14,
  };
  ws["!cols"] = headers.map(h => ({ wch: widthMap[h] || 14 }));

  // freeze after header block (row 6 is table header)
  ws["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // 5) Workbook + save
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Diesel Report");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  saveAs(blob, "diesel_report_own.xlsx");
};


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
            <h2 className="add-txt">Vehicle Diesel Report View</h2>
            <Link to={`/diesel_report_list`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="add-new-container">
  <button className="add-new-btn" onClick={exportToExcel}>
    <i className="fa-solid fa-file-excel"></i> Export to Excel
  </button>
</div>

        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map((i) => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map((i) => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                 <th>S.No</th>
                         <th>Date</th> 
                         <th>Particulars</th>
                         <th>Quantity</th>
                         <th>Cum. Diesel quantity</th>
                         <th>Basic Rate</th>
                         <th>Basic Amount</th>
                         <th>Basic Value</th>
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">
        Loading data, please wait...
      </td>
    </tr>
  ) : currentData.length > 0 ? (
    (() => {
      let dieselqty1 = 0;
      let bv = 0;
      return currentData.map((item, index) => {
        const basicval = parseFloat(item.fld_dieselqty || 0);
        const ds = basicval * dieselRate;
        dieselqty1 += basicval;
        bv += ds;

        
        // totalKm += currentKm;
        return (
          <tr key={index}>
            <td>{indexOfFirstItem + index + 1}</td>
            <td>{new Date(item.fld_vdate).toLocaleDateString()}</td>
            <td>{item.fld_vno}</td>
            <td>{item.fld_dieselqty}</td>
            <td>{dieselqty1}</td>
            <td>{dieselRate}</td>
            <td>{ds}</td>
            <td>{bv}</td>

            
          </tr>
        );
      });
    })()
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehDieselReportView;
